import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import cn from 'classnames';
import { startOfDay } from 'date-fns';
import { Box, Button, KeyboardDatePicker } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './TimePeriodSelector.module.scss';
export const SpecificRangePicker = (param)=>{
    let { initialFrom, initialTo, now, isMobileDevice, fromPickerTestId, toPickerTestId, applyButtonTestId, onApply } = param;
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const [draftFrom, setDraftFrom] = useState(initialFrom);
    const [draftTo, setDraftTo] = useState(initialTo);
    const apply = ()=>{
        const fromMs = startOfDay(new Date(draftFrom)).getTime();
        const toMs = startOfDay(new Date(draftTo)).getTime();
        onApply(fromMs, toMs);
    };
    return /*#__PURE__*/ _jsxs(Box, {
        className: cn(styles.specificRangePopover, {
            mobile: isMobileDevice
        }),
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.popoverInputs,
                children: [
                    /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                        bi: {
                            name: 'metrics_from_date'
                        },
                        testId: fromPickerTestId,
                        label: invoiceMetricsSectionTexts.timePeriodPresets.fromLabel(),
                        value: new Date(draftFrom),
                        onChange: (date)=>date != null && setDraftFrom(date.getTime()),
                        maxDate: draftTo < now.getTime() ? new Date(draftTo) : now,
                        variant: isMobileDevice ? 'dialog' : 'inline'
                    }),
                    /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                        bi: {
                            name: 'metrics_to_date'
                        },
                        testId: toPickerTestId,
                        label: invoiceMetricsSectionTexts.timePeriodPresets.toLabel(),
                        value: new Date(draftTo),
                        onChange: (date)=>date != null && setDraftTo(date.getTime()),
                        minDate: new Date(draftFrom),
                        maxDate: now,
                        variant: isMobileDevice ? 'dialog' : 'inline'
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'apply_custom_time_period'
                },
                testId: applyButtonTestId,
                onClick: apply,
                className: styles.applyButton,
                children: invoiceMetricsSectionTexts.timePeriodPresets.applyButton()
            })
        ]
    });
};
